import React from 'react';
import {Button, Form, Input, Modal, notification, Select, Typography} from "antd";
import ApiService from "../../../services/ApiService"
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;

export default class ModalAddLink extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    state = {
        visible: false,
        loading: false,
        id: null
    };

    async show(id) {
        this.setState({visible: true, id: id})
    }

    close() {
        this.setState({
            visible: false,
            loading: false,
            id: null
        })
    }

    async onSubmit(data) {
        this.setState({loading: true})

        var res = await ApiService.post("/contact/link/add/" + this.state.id, data)

        if (res.success) {
            notification.success({
                message: t`Ajout réussi`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.error({
                message: t`Erreur lors de l'ajout`
            })
        }

        this.setState({loading: false})
    }

    render() {
        return (
            <Modal
                width="100%"
                title={t`Ajouter un Lien`}
                open={this.state.visible}
                destroyOnClose
                closable
                footer={null}
                onCancel={() => this.close()}
            >

                <Form
                    onFinish={(data) => this.onSubmit(data)}
                    ref={(ref) => this.form = ref}
                    layout="vertical"
                >

                    <Form.Item
                        name="name"
                        label={t`Nom du lien`}
                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                    >
                        <Input placeholder={t`Nom du lien`} />
                    </Form.Item>

                    <Form.Item
                        label={t`Lien`}
                        name="link"
                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                        shouldUpdate
                    >
                        <Input type="url" placeholder="url" />
                    </Form.Item>

                    <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                            <Trans>Valider</Trans>
                        </Button>
                    </Form.Item>
                </Form>

            </Modal>
        )
    }
}
